import { render, staticRenderFns } from "./BookCardSectionBox.vue?vue&type=template&id=7c9c075c&scoped=true&"
import script from "./BookCardSectionBox.vue?vue&type=script&lang=js&"
export * from "./BookCardSectionBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9c075c",
  null
  
)

export default component.exports